import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseDetailUrl } from '@/utils';
import { getCutHour, getCutMinute, getCutSecond } from '@/utils/date/index.js';
import dayjs from 'dayjs';
export default {
  name: 'tour-item',
  props: {
    info: {
      type: Object,
      default: {}
    },
    len: {
      type: [String, Number],
      default: ''
    },
    onSaleTime: {
      type: Number,
      default: 0
    },
    mistiming: {
      type: Number,
      default: 0
    },
    artIndex: {
      type: Number,
      default: 0
    },
    tourIndex: {
      type: Number,
      default: 0
    }
  },
  created: function created() {
    this.btnContent(this.info);
  },
  watch: {
    info: {
      handler: function handler(val) {
        this.btnContent(val);
      },
      deep: true
    }
  },
  computed: {
    getHour: function getHour() {
      return getCutHour(this.cutCurrentTime);
    },
    getminute: function getminute() {
      return getCutMinute(this.cutCurrentTime);
    },
    getSecond: function getSecond() {
      return getCutSecond(this.cutCurrentTime);
    }
  },
  data: function data() {
    return {
      cutCurrentTime: 0,
      btnStatus: null,
      btnText: null,
      saleText: null,
      isCountDown: false
    };
  },
  methods: {
    handleGoDetail: function handleGoDetail(project) {
      var _ref = project || {},
        performanceId = _ref.performanceId,
        dataSeed = _ref.dataSeed,
        _ref$jumpDetailUrl = _ref.jumpDetailUrl,
        jumpDetailUrl = _ref$jumpDetailUrl === void 0 ? '' : _ref$jumpDetailUrl;
      if (dataSeed) {
        window.seedAction(dataSeed);
      }
      if (!performanceId) return;
      if (jumpDetailUrl) {
        this.go(parseDetailUrl(jumpDetailUrl), {
          _blank: true
        });
      } else {
        this.go("/detail/".concat(performanceId), {
          _blank: true
        });
      }
    },
    btnContent: function btnContent(_ref2) {
      var stockOutRegister = _ref2.stockOutRegister,
        unusualSaleStatus = _ref2.unusualSaleStatus,
        saleStatus = _ref2.saleStatus;
      var btnStatus;
      var btnText;
      if (saleStatus === 1) {
        btnStatus = 'normal';
        btnText = '预约抢票';
      } else if (saleStatus === 2 || saleStatus === 3) {
        btnStatus = 'normal';
        btnText = '去抢票';
      } else if ((saleStatus === 4 || saleStatus === 5) && stockOutRegister === 1) {
        btnStatus = 'stockout';
        btnText = '缺货登记';
      } else if ((saleStatus === 4 || saleStatus === 5) && stockOutRegister === 0) {
        btnStatus = 'unusual';
        btnText = '售罄';
      } else if (unusualSaleStatus === 2) {
        btnStatus = 'unusual';
        btnText = '全部延期';
      } else if ([3, 5, 6].includes(unusualSaleStatus)) {
        btnStatus = 'unusual';
        btnText = '部分延期';
      } else if (unusualSaleStatus === 4) {
        btnStatus = 'unusual';
        btnText = '部分取消';
      } else if (unusualSaleStatus === 1) {
        btnStatus = 'unusual';
        btnText = '全部取消';
      }
      this.btnStatus = btnStatus;
      this.btnText = btnText;
      this.saleText = this.renderText();
    },
    renderText: function renderText() {
      if (this.btnText !== '预约抢票') {
        this.isCountDown = false;
        if (this.btnText === '去抢票') return '火热抢购中';
        if (this.btnStatus === 'normal' && !this.onSaleTime) return '即将开抢';
        return this.btnText;
      } else {
        if (this.onSaleTime) {
          if (this.onSaleTime - Date.now() > 24 * 60 * 60 * 1000) {
            this.isCountDown = false;
            return dayjs(this.onSaleTime).format('MM月DD日 HH:mm 开抢');
          } else {
            this.isCountDown = true;
            this.setDownTime();
          }
        } else {
          this.isCountDown = false;
          return '即将开抢';
        }
      }
    },
    setDownTime: function setDownTime() {
      var _this = this;
      this.clearOnSaleInterval();
      if (!this.onSaleTimers) {
        var saleTime = this.onSaleTime;

        // const saleTime = 1725356580000
        var stepFunc = function stepFunc() {
          var current = new Date().getTime();
          var now = _this.getNowTime(current, _this.mistiming);
          if (now > saleTime) {
            // 倒计时结束
            _this.clearOnSaleInterval();
            _this.changeSaleStatus(); // 转换状态
          } else {
            _this.cutCurrentTime = saleTime - now;
            _this.onSaleTimers = window.requestAnimationFrame(stepFunc);
          }
        };
        this.onSaleTimers = window.requestAnimationFrame(stepFunc);
      }
    },
    clearOnSaleInterval: function clearOnSaleInterval() {
      if (this.onSaleTimers) {
        window.cancelAnimationFrame(this.onSaleTimers);
        this.onSaleTimers = null;
      }
    },
    changeSaleStatus: function changeSaleStatus() {
      // 切换到已开售状态
      this.$emit('changeSaleStatus', {
        artIndex: this.artIndex,
        tourIndex: this.tourIndex
      });
    },
    getNowTime: function getNowTime(current, mistiming) {
      // 获取准确的服务器当前时间
      return current - mistiming;
    }
  }
};